var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 499.27950310559004 0 Q 510.4099378881988 1.5900621118012421 512 12.720496894409937 L 512 394.3354037267081 L 512 394.3354037267081 Q 510.4099378881988 405.46583850931677 499.27950310559004 407.055900621118 Q 488.14906832298135 405.46583850931677 486.55900621118013 394.3354037267081 L 486.55900621118013 42.93167701863354 L 486.55900621118013 42.93167701863354 L 25.440993788819874 505.639751552795 L 25.440993788819874 505.639751552795 Q 15.900621118012422 512 6.3602484472049685 505.639751552795 Q 0 496.0993788819876 6.3602484472049685 486.55900621118013 L 469.06832298136646 25.440993788819874 L 469.06832298136646 25.440993788819874 L 117.66459627329192 25.440993788819874 L 117.66459627329192 25.440993788819874 Q 106.53416149068323 23.850931677018632 104.94409937888199 12.720496894409937 Q 106.53416149068323 1.5900621118012421 117.66459627329192 0 L 499.27950310559004 0 L 499.27950310559004 0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.cc0955b6605147c3fe59aa83c9497601.svg";
export { ForwardRef as ReactComponent };